import { render, staticRenderFns } from "./EdgeProps.vue?vue&type=template&id=f416ee94&scoped=true"
import script from "./EdgeProps.vue?vue&type=script&lang=js"
export * from "./EdgeProps.vue?vue&type=script&lang=js"
import style0 from "./EdgeProps.vue?vue&type=style&index=0&id=f416ee94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f416ee94",
  null
  
)

export default component.exports